import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6836b03a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "拖拽排序", -1))

import { ref } from 'vue'
import draggable from 'vuedraggable'


const __default__ = { name: 'Example' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const plainOptions = ref([
  { id: 1, name: '姓名' },
  { id: 2, name: '年龄' },
  { id: 3, name: '性别' },
  { id: 4, name: '出生日期' },
  { id: 5, name: '兴趣爱好' }
])

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_unref(draggable), {
            tag: "a-checkbox-group",
            list: plainOptions.value,
            "item-key": "id"
          }, {
            item: _withCtx(({ element }) => [
              _createElementVNode("div", null, [
                _createVNode(_component_a_checkbox, {
                  value: element.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(element.name), 1)
                  ]),
                  _: 2
                }, 1032, ["value"])
              ])
            ]),
            _: 1
          }, 8, ["list"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})